export default __webpack_public_path__ + "9c8f0f10d03d2b5362f82c14d3879486.png";